module.exports = __webpack_public_path__ + "img/buildings.959f64eb.png";